import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Icons from '../../../assets/icons/index'
import styled from './SaleOrderDetail.module.css'
import callApi from "../../../services/api/apiClient"
import ModalProvider from "../../../components/modal/ModalProvider"
import { useToast } from '../../../components/toast/Toast';

const SaleOrderDetail = () => {
    const navigate = useNavigate()
    const { saleOrderId } = useParams();
    const [detail, setDetail] = useState(null)
    const [isDelete, setIsDelete] = useState(false)
    const [orderlinesId, setOrderlinesId] = useState(null)

    const { showToast } = useToast()

    useEffect(() => {
        getSaleOrderDetail()
    }, [])

    const getSaleOrderDetail = () => {
        callApi('saleOrder/getSaleOrderDetail')
            .withSegment(saleOrderId)
            .loadingGroup('SaleOrderDetail')
            .execute()
            .then(res => {
                setDetail(res)
            })
    }

    const onDeleteOrderLines = () => {
        callApi('saleOrder/deleteSaleOrderLine')
            .withKeyParameter({ saleOrderId: saleOrderId, saleOrderLineId: orderlinesId })
            .loadingGroup('SaleOrderDetail')
            .execute()
            .then(res => {
                if (res?.status === 'success') {
                    getSaleOrderDetail()
                    setIsDelete(false)
                    showToast('Delete Order Lines is successful!', 'success');
                } else {
                    console.log("ERROR", res?.error)
                    setIsDelete(false)
                    showToast(res?.message ? res?.message : res?.error, 'error');
                }
            })
    }

    console.log("DETAIL", detail)

    return (
        <div className={styled.list_container}>
            <div className="flex">
                <div onClick={() => navigate('/sale_order')}>
                    <img src={Icons.back} alt="" className="w-[24px] h-[24px]" />
                </div>
                <p className={styled.title}>Live Sale {detail?.name} - [Sale Order 35560] {detail?.customer?.name}</p>
            </div>
            <table className="flex-1 table-auto w-full mt-[40px]">
                <thead className="text-left">
                    <tr className={styled.table_header_row}>
                        <th className="">Product</th>
                        <th>Product No.</th>
                        <th>P-Code</th>
                        <th>Price</th>
                        <th>Cx-Code</th>
                        <th>Phone</th>
                        <th>Location</th>
                        <th className="text-center">Action</th>
                        <th className="w-1/12"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        detail?.order_lines?.length > 0 ? detail?.order_lines?.map((item, index) => (
                            <tr className="h-[64px] border-b border-b-black-2">
                                <td>
                                    {item?.image ?
                                        <img src={item?.image} alt="" className="w-[56px] h-[48px]" />
                                        :
                                        <img src={Icons.defaultImage} alt="" className="w-[56px] h-[48px]" />}
                                </td>
                                <td className={`${styled.table_body_column} font-interSemiBold`}>
                                    <span className="cursor-pointer">{item?.lot_no?.name}</span>
                                </td>
                                <td className={`${styled.table_body_column} font-interRegular`}>{item?.code ? item?.code : '-'}</td>
                                <td className={`${styled.table_body_column} font-interRegular`}>{item?.price ? item?.price : '-'}</td>
                                <td className={`${styled.table_body_column} font-interRegular`}>YGN245</td>
                                <td className={`${styled.table_body_column} font-interRegular`}>09789445132</td>
                                <td className={`${styled.table_body_column} font-interRegular`}>{item?.address ? item?.address : '-'}</td>
                                <td className="flex-1">
                                    <div className="cursor-pointer  items-center flex justify-center" onClick={() => {
                                        setIsDelete(true)
                                        setOrderlinesId(item?.id)
                                    }}>
                                        <img src={Icons.bin} alt="" className="w-[22px] h-[20px]" />
                                    </div>
                                </td>
                                <td className="w-1/12"></td>
                            </tr>
                        ))
                            :
                            <div className="mt-3 text-center">
                                <p>There is no data.</p>
                            </div>
                    }
                </tbody>
            </table>
            <ModalProvider
                isOpen={isDelete}
                onClose={() => setIsDelete(false)}
                title={'Delete Sale Order Lines'}
                cancelBtn={() => setIsDelete(false)}
                sendBtn={() => onDeleteOrderLines()}
                description={'Are you sure you want to  delete order lines?'} />
        </div>
    )
}
export default SaleOrderDetail